// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.login-form {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2.5rem;
    width: 410px;
    height: 550px;
    border-radius: 10px;
    margin: auto;
    box-shadow: 0 2px 3px 1px rgba(0, 0, 0, 0.1);
}

.login-form .input-container {
    position: relative;
    display: flex;
    flex-direction: column;
}
  
.login-form input {
    width: 100%;
    padding: .5rem .5rem .6rem 3rem;
    height: 3rem;
    border: none;
    margin-bottom: 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 500;
    background-color: var(--fundo-input);
    transition: all .03s;
    color: var(--text-color);
    font-weight: 400;
}

.login-form input::placeholder {
    color: var(--cinza-padrao);
}

.login-form input:focus, .login-form input:hover {
    outline: 2px solid var(--azul-dixi);
}

.login-form input.invalido {
    outline: 1px solid var(--error-color);
}

.texto-campo-invalido {
    text-align: center;
    color: var(--error-color);
    margin-bottom: 1rem;
}

.login-form i {
    position: absolute;
    font-size: 1.8rem;
    font-weight: thin;
    color: var(--cinza-padrao);
}

.login-user-icon, .login-lock-icon {
    top: 14%;
    left: 3%;
}

.login-eye-icon {
    top: 17%;
    right: 4%;
}

.login-eye-icon:hover {
    cursor: pointer;
    color: var(--azul-dixi);
}

.login-eye-icon.olho-aberto {
    color: var(--azul-dixi);
}

.login-form a {
    font-size: .9rem;
    display: block;
    text-align: center;
    margin-bottom: 1rem;
    color: var(--azul-dixi);
    font-weight: bold;
    text-decoration: none;
    margin: .3rem 0 1.7rem 0;
}
  
.login-form button {
    width: 100%;
    padding: .5rem;
    height: 3rem;
    border: none;
    border-radius: 10px;
    background-color: var(--azul-dixi);
    color: #fff;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: 400;
    margin-top: 1rem;
    min-height: 3rem;
}
  
.login-form button:hover {
    background-color: var(--botao-hover);
}   
  `, "",{"version":3,"sources":["webpack://./src/components/LoginForm/LoginForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,oBAAoB;IACpB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n.login-form {\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 2.5rem;\n    width: 410px;\n    height: 550px;\n    border-radius: 10px;\n    margin: auto;\n    box-shadow: 0 2px 3px 1px rgba(0, 0, 0, 0.1);\n}\n\n.login-form .input-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n  \n.login-form input {\n    width: 100%;\n    padding: .5rem .5rem .6rem 3rem;\n    height: 3rem;\n    border: none;\n    margin-bottom: 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 500;\n    background-color: var(--fundo-input);\n    transition: all .03s;\n    color: var(--text-color);\n    font-weight: 400;\n}\n\n.login-form input::placeholder {\n    color: var(--cinza-padrao);\n}\n\n.login-form input:focus, .login-form input:hover {\n    outline: 2px solid var(--azul-dixi);\n}\n\n.login-form input.invalido {\n    outline: 1px solid var(--error-color);\n}\n\n.texto-campo-invalido {\n    text-align: center;\n    color: var(--error-color);\n    margin-bottom: 1rem;\n}\n\n.login-form i {\n    position: absolute;\n    font-size: 1.8rem;\n    font-weight: thin;\n    color: var(--cinza-padrao);\n}\n\n.login-user-icon, .login-lock-icon {\n    top: 14%;\n    left: 3%;\n}\n\n.login-eye-icon {\n    top: 17%;\n    right: 4%;\n}\n\n.login-eye-icon:hover {\n    cursor: pointer;\n    color: var(--azul-dixi);\n}\n\n.login-eye-icon.olho-aberto {\n    color: var(--azul-dixi);\n}\n\n.login-form a {\n    font-size: .9rem;\n    display: block;\n    text-align: center;\n    margin-bottom: 1rem;\n    color: var(--azul-dixi);\n    font-weight: bold;\n    text-decoration: none;\n    margin: .3rem 0 1.7rem 0;\n}\n  \n.login-form button {\n    width: 100%;\n    padding: .5rem;\n    height: 3rem;\n    border: none;\n    border-radius: 10px;\n    background-color: var(--azul-dixi);\n    color: #fff;\n    cursor: pointer;\n    font-size: 1.1rem;\n    font-weight: 400;\n    margin-top: 1rem;\n    min-height: 3rem;\n}\n  \n.login-form button:hover {\n    background-color: var(--botao-hover);\n}   \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
